import React, {ReactNode} from "react"

import {H4, Body} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"

import {StyledSignUpOption} from "./styled"

interface Props {
  id?: string
  onClick: () => void
  active: boolean
  children: ReactNode
  title: string
  description: string
}

const SignUpOption = ({active = false, onClick, title, description, children, id}: Props) => {
  return (
    <StyledSignUpOption id={id} active={active} onClick={onClick}>
      <H4 marginBottom={1}>{title}</H4>
      <Body>{description}</Body>
      {active && <Spacing marginTop={3}>{children}</Spacing>}
    </StyledSignUpOption>
  )
}

export default SignUpOption
